/* eslint-disable */
import axios, { AxiosPromise } from 'axios';
import cookie from 'cookie_js';
import * as Redux from 'redux';
import {
  addTime,
  formatDate,
  isWithinInterval,
  setDate,
  toSeconds,
  zonedToUtc,
} from '../utils/dateTimeUtils';

import { FindInitialRestaurant } from './actions/Actions';
import * as Api from './Api';
import * as Basket from './BasketControl';
import { Sorted } from './Data';
import { storage } from './services/storageServices';
import * as Store from './Store';
import { getStoreInstance } from './Store';

const _ = require('lodash');

const difference = (object, base) => {
  const changes = (object, base) => {
    return _.transform(object, function(result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, base[key])
            : value;
      }
    });
  };
  return changes(object, base);
};

const trimBasket = (basket: Basket.Data): any => {
  const newBasket: any[] = [];

  for (const item of basket.items) {
    const newItem: any = {
      Name: item.Item.Name,
      MenuItemId: item.Item.Name,
      Price: item.Item.Price,
    };

    const newOptions: any[] = [];

    for (const option of item.Options) {
      const newOption: any = {
        Name: option.Name,
        MenuItemOptionSetItemId: option.MenuItemOptionSetItemId,
        Price: option.Price,
      };

      newOptions.push(newOption);
    }

    newBasket.push({
      Item: newItem,
      Options: newOptions,
    });
  }

  return newBasket;
};

const handleError = (e: any): any => {
  if (e.response) {
    return e.response;
  } else if (e.request) {
    return e.request;
  } else {
    return e.message;
  }
};

export class CredentialsAuth {
  public applyToRequest(requestOptions): void {
    requestOptions.withCredentials = true;
  }
}

// http://stackoverflow.com/a/36876507/249879
const startsWith = (s: string, word: string): boolean => {
  return s.lastIndexOf(word, 0) === 0;
};

const isValidEmail = (email: string) => {
  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

// Modified from https://github.com/JamesEggers1/node-luhn
// Copyright (c) 2012 James Eggers
// Licesne: MIT
// https://github.com/JamesEggers1/node-luhn/blob/master/LICENSE
const isValidCreditCard = (cardNumber: string) => {
  const trimmed = String(cardNumber).replace(/[\s]/g, '');
  const length = trimmed.length;

  if (length === 0) {
    return true;
  }

  if (!/^[0-9]+$/.test(trimmed)) {
    return false;
  }

  let odd = false;
  let total = 0;
  let calc: number;
  let calc2: number;

  for (let i = length; i > 0; i--) {
    calc = parseInt(trimmed.charAt(i - 1));
    if (!odd) {
      total += calc;
    } else {
      calc2 = calc * 2;

      switch (calc2) {
        case 10:
          calc2 = 1;
          break;
        case 12:
          calc2 = 3;
          break;
        case 14:
          calc2 = 5;
          break;
        case 16:
          calc2 = 7;
          break;
        case 18:
          calc2 = 9;
          break;
      }
      total += calc2;
    }
    odd = !odd;
  }

  return total % 10 === 0;
};

const loadMenu = (
  RestaurantSummaries: Api.RestaurantSummaryCommon[],
  dispatch: Redux.Dispatch<Redux.Action>,
  getState: () => Store.State,
  refresh: boolean,
  iteration?: number,
) => {
  const ApiRequestMenuUrls = [];

  for (const RestaurantSummary of RestaurantSummaries) {
    const MenuData = getState().flipdish.MenuData;
    const pendingAction: Store.MenuDataPanding = {
      type: 'MENU_DATA_PENDING',
      menuKey: RestaurantSummary.MenuUrl,
    };

    let existingMenuData = MenuData[RestaurantSummary.MenuUrl];

    //If menu doesn't exist in the redux store dispatch pending and get menu from localStorage if it exists
    if (!existingMenuData) {
      dispatch(pendingAction);

      const menuJson = storage.getItem<Api.MenuReposnse>(
        RestaurantSummary.MenuUrl,
      );

      if (menuJson) {
        menuJson.FromAPI = false;

        const action: Store.AddMenuData = {
          type: 'ADD_MENU_DATA',
          menuKey: RestaurantSummary.MenuUrl,
          menu: menuJson,
        };

        dispatch(action);
      }
    }

    //Check for if the menu data in the redux store has been got from the API
    let existingMenuFromAPI = false;

    existingMenuData = MenuData[RestaurantSummary.MenuUrl];

    if (existingMenuData && existingMenuData.status === 'success') {
      existingMenuFromAPI = existingMenuData.data.FromAPI;
    }

    //If menu data is from API and new data is not required, go to next iteration
    if (existingMenuFromAPI && !refresh) {
      continue;
    }

    //When loading menus check that API call is not made twice for the same menu
    if (
      ApiRequestMenuUrls.findIndex(
        (ApiRequestMenuUrl) => ApiRequestMenuUrl === RestaurantSummary.MenuUrl,
      ) !== -1
    ) {
      continue;
    }

    ApiRequestMenuUrls.push(RestaurantSummary.MenuUrl);

    axios({
      method: 'get',
      url: RestaurantSummary.MenuUrl,
      withCredentials: false,
    })
      .then((result) => {
        const menu: Api.MenuReposnse = result.data;
        menu.FromAPI = true;

        //Arrange sections by DisplayOrder
        menu.MenuSections = Sorted(menu.MenuSections);

        const action: Store.AddMenuData = {
          type: 'ADD_MENU_DATA',
          menuKey: RestaurantSummary.MenuUrl,
          menu,
        };

        dispatch(action);
      })
      .catch((_error) => {
        if (!iteration) {
          setTimeout(() => {
            FindInitialRestaurant(() => {}, 2);
          }, 5000);
        } else if (iteration >= 12) {
          // Raven.captureMessage('Unable to get menu', {
          //   extra: {
          //     url: RestaurantSummary.MenuUrl,
          //   },
          // });
        } else {
          setTimeout(() => {
            FindInitialRestaurant(() => {}, iteration + 1);
          }, 5000);
        }
      });
  }
};

const arrayMove = function(arr, old_index, new_index): any {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
};

const UUID = function(): string {
  let d = new Date().getTime();

  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c,
  ) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return uuid;
};

// Generate a UUID
// http://stackoverflow.com/a/8809472/249879
const DeviceId = function(): string {
  const key = 'flipdish-device-id';
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  try {
    const deviceId: string | null = storage.getItem(key);
    if (deviceId && deviceId.match(uuid)) {
      return deviceId;
    }

    const newDeviceId = UUID();
    setInLocalStorage(key, newDeviceId);
    return newDeviceId;
  } catch (error) {
    console.warn(error);
  }

  // No local storage, make a new device ID each time.
  return UUID();
};

const getOpeningTime = (restaurant: Api.RestaurantDetail): string => {
  const openTimeMinuteString = ('00' + restaurant.OpenTimeMinute).slice(-2);
  const openTimeHourString = ('00' + restaurant.OpenTimeHour).slice(-2);
  return '' + openTimeHourString + ':' + openTimeMinuteString;
};

// Return a new array which contains the elements of the input with the item at index removed.
const removeFromArray = function<T>(array: T[], index: number): T[] {
  const dup = array.slice();
  dup.splice(index, 1);
  return dup;
};

const findAndRemove = function<T>(array: T[], item: T): T[] {
  let dup = array.slice();
  // eslint-disable-next-line eqeqeq
  dup = dup.filter((element: T) => element != item);
  return dup;
};

const isInFrame = function(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

// Please use utils urlUtils.navigateTo instead. This function is deprecated.
const navigateTo = (hash: string) => {
  window.location.hash = hash;
};

// Please use utils domUtils.ensureVisible instead. This function is deprecated.
const ensureVisible = (element: Element | null | Text) => {
  if (!element) {
    return;
  }

  const asElement = element as Element;
  const rect =
    asElement.getBoundingClientRect && asElement.getBoundingClientRect();
  if (!rect) {
    return;
  }
  const visible: boolean =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

  if (visible) {
    return;
  }

  asElement.scrollIntoView();
};

const getUserMessage = (axiosError: any) => {
  const { response } = axiosError;
  if (!response || !response.data) {
    return 'Network error';
  }
  const { DeveloperMessage, UserMessage } = response.data;
  return DeveloperMessage || UserMessage || 'Unknown Error';
};

const toPromise = function<T>(request: AxiosPromise): Promise<T> {
  return new Promise((resolve, reject) => {
    request.catch(reject);
    request.then((result) => {
      const data: Api.Result<T> = result.data;
      if (data.Success) {
        resolve(data.Data);
      } else {
        reject(data);
      }
    });
  });
};

const { userAgent } = navigator;
const isAndroid = /Android/i.test(userAgent);
const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
const isIOSPhone = /iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
const isFirefox = /firefox/i.test(userAgent);
const isChrome = (window as any).chrome;
const isStandalone =
  (navigator as any).standalone === true ||
  (window?.matchMedia &&
    window?.matchMedia('(display-mode: standalone)').matches);

const browserHasLocation = (): boolean => {
  if (!navigator.geolocation) {
    return false;
  }

  if (isChrome || isFirefox || isAndroid) {
    return (window as any).isSecureContext;
  }

  // Fallback - https only.
  return window.location.protocol === 'https:';
};

//For replacing character elements in a string to JSX
const stringToJSX = (array: string[], fn: Function) => {
  let result: JSX.Element[] = [];
  for (let i = 0; i < array.length; i++) {
    const mapping = fn(array[i], i);
    result = result.concat(mapping);
  }
  return result;
};

//For mapping time keys to time values
const preorderInfoText = (type: Api.DeliveryType): string => {
  if (type === Api.DeliveryType.Delivery) {
    return '-Select Delivery Time-';
  }

  return '-Select Collection Time-';
};

//For converting timezone from Microsoft format to moment format
const convertTimeZone = (TimeZoneInfoId: string): string => {
  let timeZone = 'GMT';

  switch (TimeZoneInfoId) {
    case 'Samoa Standard Time':
      timeZone = 'Pacific/Samoa';
      break;
    case 'Hawaiian Standard Time':
      timeZone = 'US/Hawaii';
      break;
    case 'Alaskan Standard Time':
      timeZone = 'US/Alaska';
      break;
    case 'Pacific Standard Time':
      timeZone = 'US/Pacific';
      break;
    case 'Mountain Standard Time':
    case 'U.S. Mountain Standard Time':
      timeZone = 'US/Mountain';
      break;
    case 'Mexico Standard Time 2':
      timeZone = 'America/Chihuahua';
      break;
    case 'Central Standard Time':
      timeZone = 'US/Central';
      break;
    case 'Canada Central Standard Time':
      timeZone = 'Canada/Central';
      break;
    case 'Mexico Standard Time':
      timeZone = 'America/Mexico_City';
      break;
    case 'Central America Standard Time':
      timeZone = 'America/Guatemala';
      break;
    case 'Eastern Standard Time':
    case 'U.S. Eastern Standard Time':
      timeZone = 'US/Eastern';
      break;
    case 'S.A. Pacific Standard Time':
      timeZone = 'America/Lima';
      break;
    case 'Atlantic Standard Time':
      timeZone = 'Canada/Atlantic';
      break;
    case 'S.A. Western Standard Time':
      timeZone = 'America/Caracas';
      break;
    case 'Pacific S.A. Standard Time':
      timeZone = 'America/Santiago';
      break;
    case 'Newfoundland and Labrador Standard Time':
      timeZone = 'Canada/Newfoundland';
      break;
    case 'E. South America Standard Time':
      timeZone = 'Brazil/East';
      break;
    case 'S.A. Eastern Standard Time':
    case 'Greenland Standard Time':
      timeZone = 'America/Buenos_Aires';
      break;
    case 'Azores Standard Time':
      timeZone = 'Atlantic/Azores';
      break;
    case 'Cape Verde Standard Time':
      timeZone = 'Atlantic/Cape_Verde';
      break;
    case 'GMT Standard Time':
    case 'Greenwich Standard Time':
      timeZone = 'Europe/Dublin';
      break;
    case 'Central Europe Standard Time':
      timeZone = 'Europe/Belgrade';
      break;
    case 'Central European Standard Time':
      timeZone = 'Europe/Sarajevo';
      break;
    case 'Romance Standard Time':
      timeZone = 'Europe/Paris';
      break;
    case 'W. Europe Standard Time':
      timeZone = 'Europe/Amsterdam';
      break;
    case 'W. Central Africa Standard Time':
      timeZone = 'Africa/Luanda';
      break;
    case 'E. Europe Standard Time':
      timeZone = 'Europe/Bucharest';
      break;
    case 'Egypt Standard Time':
      timeZone = 'Africa/Cairo';
      break;
    case 'FLE Standard Time':
      timeZone = 'Europe/Helsinki';
      break;
    case 'GTB Standard Time':
      timeZone = 'Europe/Athens';
      break;
    case 'Israel Standard Time':
      timeZone = 'Israel';
      break;
    case 'South Africa Standard Time':
      timeZone = 'Africa/Johannesburg';
      break;
    case 'Russian Standard Time':
      timeZone = 'Europe/Moscow';
      break;
    case 'Arab Standard Time':
      timeZone = 'Asia/Kuwait';
      break;
    case 'E. Africa Standard Time':
      timeZone = 'Africa/Nairobi';
      break;
    case 'Arabic Standard Time':
      timeZone = 'Asia/Baghdad';
      break;
    case 'Iran Standard Time':
      timeZone = 'Asia/Tehran';
      break;
    case 'Arabian Standard Time':
      timeZone = 'Asia/Muscat';
      break;
    case 'Caucasus Standard Time':
      timeZone = 'Asia/Baku';
      break;
    case 'Transitional Islamic State of Afghanistan Standard Time':
      timeZone = 'Asia/Kabul';
      break;
    case 'Ekaterinburg Standard Time':
      timeZone = 'Asia/Yekaterinburg';
      break;
    case 'West Asia Standard Time':
      timeZone = 'Asia/Karachi';
      break;
    case 'India Standard Time':
      timeZone = 'Asia/Kolkata';
      break;
    case 'Nepal Standard Time':
      timeZone = 'Asia/Kathmandu';
      break;
    case 'Central Asia Standard Time':
      timeZone = 'Asia/Dhaka';
      break;
    case 'Sri Lanka Standard Time':
      timeZone = 'Asia/Colombo';
      break;
    case 'N. Central Asia Standard Time':
      timeZone = 'Asia/Almaty';
      break;
    case 'Myanmar Standard Time':
      timeZone = 'Asia/Yangon';
      break;
    case 'SE Asia Standard Time':
      timeZone = 'Asia/Bangkok';
      break;
    case 'North Asia Standard Time':
      timeZone = 'Asia/Krasnoyarsk';
      break;
    case 'China Standard Time':
      timeZone = 'Asia/Hong_Kong';
      break;
    case 'Singapore Standard Time':
      timeZone = 'Asia/Singapore';
      break;
    case 'Taipei Standard Time':
      timeZone = 'Asia/Taipei';
      break;
    case 'W. Australia Standard Time':
      timeZone = 'Australia/Perth';
      break;
    case 'North Asia East Standard Time':
      timeZone = 'Asia/Irkutsk';
      break;
    case 'Korea Standard Time':
      timeZone = 'Asia/Seoul';
      break;
    case 'Tokyo Standard Time':
      timeZone = 'Asia/Tokyo';
      break;
    case 'Yakutsk Standard Time':
      timeZone = 'Asia/Yakutsk';
      break;
    case 'A.U.S. Central Standard Time':
      timeZone = 'Australia/Darwin';
      break;
    case 'Cen. Australia Standard Time':
      timeZone = 'Australia/Adelaide';
      break;
    case 'A.U.S. Eastern Standard Time':
      timeZone = 'Australia/Sydney';
      break;
    case 'E. Australia Standard Time':
      timeZone = 'Australia/Brisbane';
      break;
    case 'Tasmania Standard Time':
      timeZone = 'Australia/Hobart';
      break;
    case 'Vladivostok Standard Time':
      timeZone = 'Asia/Vladivostok';
      break;
    case 'West Pacific Standard Time':
      timeZone = 'Pacific/Guam';
      break;
    case 'Central Pacific Standard Time':
      timeZone = 'Asia/Magadan';
      break;
    case 'Fiji Islands Standard Time':
      timeZone = 'Pacific/Fiji';
      break;
    case 'New Zealand Standard Time':
      timeZone = 'Pacific/Auckland';
      break;
    case 'Tonga Standard Time':
      timeZone = 'Pacific/Tongatapu';
      break;
  }
  return timeZone;
};

//taken from https://docs.microsoft.com/en-us/windows-hardware/manufacture/desktop/default-time-zones
const TimezoneIdCountryCodeMap = {
  'Afghanistan Standard Time': 'AF',
  'FLE Standard Time': 'UA',
  'Central Europe Standard Time': 'SI',
  'W. Central Africa Standard Time': 'TN',
  'UTC-11': 'UM',
  'W. Europe Standard Time': 'VA',
  'SA Western Standard Time': 'VG',
  'Pacific SA Standard Time': 'CL',
  'Argentina Standard Time': 'AR',
  'Caucasus Standard Time': 'AM',
  'AUS Eastern Standard Time': 'AU',
  'Azerbaijan Standard Time': 'AZ',
  'Eastern Standard Time': 'TC',
  'Arab Standard Time': 'YE',
  'Bangladesh Standard Time': 'BT',
  'Belarus Standard Time': 'BY',
  'Romance Standard Time': 'ES',
  'Central America Standard Time': 'NI',
  'Atlantic Standard Time': 'BM',
  'Venezuela Standard Time': 'VE',
  'Central European Standard Time': 'PL',
  'South Africa Standard Time': 'ZW',
  UTC: 'BV',
  'E. South America Standard Time': 'BR',
  'Central Asia Standard Time': 'KG',
  'Singapore Standard Time': 'SG',
  'Greenwich Standard Time': 'TG',
  'Cape Verde Standard Time': 'CV',
  'SE Asia Standard Time': 'VN',
  'SA Pacific Standard Time': 'PE',
  'China Standard Time': 'MO',
  'Myanmar Standard Time': 'MM',
  'E. Africa Standard Time': 'UG',
  'Hawaiian Standard Time': 'PF',
  'E. Europe Standard Time': 'LY',
  'Tokyo Standard Time': 'PW',
  'Egypt Standard Time': 'PS',
  'SA Eastern Standard Time': 'SR',
  'GMT Standard Time': 'GB',
  'Fiji Standard Time': 'FJ',
  'West Asia Standard Time': 'UZ',
  'Georgian Standard Time': 'GE',
  'GTB Standard Time': 'RO',
  'Greenland Standard Time': 'PM',
  'West Pacific Standard Time': 'PG',
  'Mauritius Standard Time': 'SC',
  'India Standard Time': 'IN',
  'Iran Standard Time': 'IR',
  'Arabic Standard Time': 'IQ',
  'Israel Standard Time': 'IL',
  'Jordan Standard Time': 'JO',
  'UTC+12': 'WF',
  'Korea Standard Time': 'KP',
  'Middle East Standard Time': 'LB',
  'Central Standard Time (Mexico)': 'MX',
  'Ulaanbaatar Standard Time': 'MN',
  'Morocco Standard Time': 'MA',
  'Namibia Standard Time': 'NA',
  'Nepal Standard Time': 'NP',
  'Central Pacific Standard Time': 'VU',
  'New Zealand Standard Time': 'NZ',
  'Arabian Standard Time': 'AE',
  'Pakistan Standard Time': 'PK',
  'Paraguay Standard Time': 'PY',
  'Pacific Standard Time': 'US',
  'Russian Standard Time': 'RU',
  'Samoa Standard Time': 'WS',
  'UTC-02': 'GS',
  'Sri Lanka Standard Time': 'LK',
  'Syria Standard Time': 'SY',
  'Taipei Standard Time': 'TW',
  'Tonga Standard Time': 'TO',
  'Turkey Standard Time': 'TR',
  'Montevideo Standard Time': 'UY',
};
const timezoneIdToCountryCode = (timezoneId: string) => {
  return TimezoneIdCountryCodeMap[timezoneId] || 'IE';
};

// TODO move to selector
const isInPeriod = (
  AvailableTimes: Api.BusinessHoursPeriod[],
  TimeZoneInfoId: string,
): boolean => {
  if (!AvailableTimes) {
    return false;
  }

  let isInPeriod = false;
  for (const AvailableTime of AvailableTimes) {
    const timeZone = convertTimeZone(TimeZoneInfoId);

    const startTimeFormatted = formatDate(AvailableTime.StartTime, 'HH:mm:ss');

    const zonedStartTime = zonedToUtc(
      setDate(startTimeFormatted, AvailableTime.DayOfWeek, 'day'),
      timeZone,
    );

    const periodArray = AvailableTime.Period.split(':');

    const seconds = toSeconds(
      +periodArray[0] || 0,
      +periodArray[1] || 0,
      +periodArray[2] || 0,
    );
    const endTime = addTime(zonedStartTime, 'seconds', seconds);

    isInPeriod = isWithinInterval(
      new Date(),
      zonedStartTime,
      endTime,
      'seconds',
    );

    if (isInPeriod) {
      break;
    }

    if (
      AvailableTime.StartTimeEarly != null &&
      AvailableTime.PeriodEarly != null
    ) {
      const startTimeEarlyFormatted = formatDate(
        AvailableTime.StartTimeEarly,
        'HH:mm:ss',
      );

      const zonedStartTimeEarly = zonedToUtc(
        setDate(startTimeEarlyFormatted, AvailableTime.DayOfWeek, 'day'),
        timeZone,
      );

      const periodEarlyArray = AvailableTime.Period.split(':');
      const seconds = toSeconds(
        +periodEarlyArray[0] || 0,
        +periodEarlyArray[1] || 0,
        +periodEarlyArray[2] || 0,
      );

      const endTimeEarly = addTime(zonedStartTimeEarly, 'seconds', seconds);

      isInPeriod = isWithinInterval(
        new Date(),
        endTimeEarly,
        endTimeEarly,
        'seconds',
      );

      if (isInPeriod) {
        break;
      }
    }
  }

  return isInPeriod;
};

const retry = (isDone: any, next: any): any => {
  let current_trial = 0,
    max_retry = 50,
    is_timeout = false;
  const id = window.setInterval(function() {
    if (isDone()) {
      window.clearInterval(id);
      next(is_timeout);
    }
    if (current_trial++ > max_retry) {
      window.clearInterval(id);
      is_timeout = true;
      next(is_timeout);
    }
  }, 10);
};

const isIE10OrLater = (user_agent: any): any => {
  const ua = user_agent.toLowerCase();
  if (ua.indexOf('msie') === 0 && ua.indexOf('trident') === 0) {
    return false;
  }
  // eslint-disable-next-line no-useless-escape
  const match = /(?:msie|rv:)\s?([\d\.]+)/.exec(ua);
  if (match && parseInt(match[1], 10) >= 10) {
    return true;
  }
  return false;
};

const detectPrivateMode = (callback: any): any => {
  let is_private: any;

  if ((window as any).webkitRequestFileSystem) {
    (window as any).webkitRequestFileSystem(
      (window as any).TEMPORARY,
      1,
      function() {
        is_private = false;
      },
      function(e: any) {
        console.log(e);
        is_private = true;
      },
    );
  } else if (window.indexedDB && /Firefox/.test(window.navigator.userAgent)) {
    let db: any;
    try {
      db = window.indexedDB.open('test');
    } catch (e) {
      is_private = true;
    }

    if (typeof is_private === 'undefined') {
      retry(
        function isDone() {
          return db.readyState === 'done' ? true : false;
        },
        function next(is_timeout: any) {
          if (!is_timeout) {
            is_private = db.result ? false : true;
          }
        },
      );
    }
  } else if (isIE10OrLater(window.navigator.userAgent)) {
    is_private = false;
    try {
      if (!window.indexedDB) {
        is_private = true;
      }
    } catch (e) {
      is_private = true;
    }
  } else if (
    /Safari/.test(window.navigator.userAgent) &&
    navigator.cookieEnabled &&
    window.localStorage
  ) {
    if (
      !window.indexedDB &&
      ((window as any).PointerEvent || (window as any).MSPointerEvent)
    ) {
      is_private = true;
    }
    try {
      window.localStorage.setItem('test', '1');
    } catch (e) {
      is_private = true;
    }

    if (typeof is_private === 'undefined') {
      is_private = false;
      window.localStorage.removeItem('test');
    }
  }

  retry(
    function isDone() {
      return typeof is_private !== 'undefined' ? true : false;
    },
    function next() {
      callback(is_private);
    },
  );
};

/**
 * Fire an event handler to the specified node. Event handlers can detect that the event was fired programatically
 * by testing for a 'synthetic=true' property on the event object
 * @param {HTMLNode} node The node to fire the event handler on.
 * @param {String} eventName The name of the event without the "on" (e.g., "focus")
 */
const fireEvent = (node: any, eventName: string): any => {
  // Make sure we use the ownerDocument from the provided node to avoid cross-window problems
  let doc;
  if (node.ownerDocument) {
    doc = node.ownerDocument;
  } else if (node.nodeType === 9) {
    // the node may be the document itself, nodeType 9 = DOCUMENT_NODE
    doc = node;
  } else {
    throw new Error('Invalid node passed to fireEvent: ' + node.id);
  }

  if (node.dispatchEvent) {
    // Gecko-style approach (now the standard) takes more work
    let eventClass = '';

    // Different events have different event classes.
    // If this switch statement can't map an eventName to an eventClass,
    // the event firing is going to fail.
    switch (eventName) {
      case 'click': // Dispatching of 'click' appears to not work correctly in Safari. Use 'mousedown' or 'mouseup' instead.
      case 'mousedown':
      case 'mouseup':
        eventClass = 'MouseEvents';
        break;

      case 'focus':
      case 'change':
      case 'blur':
      case 'select':
        eventClass = 'HTMLEvents';
        break;

      default:
        throw new Error(
          "fireEvent: Couldn't find an event class for event '" +
            eventName +
            "'.",
        );
    }
    const event = doc.createEvent(eventClass);
    event.initEvent(eventName, true, true); // All events created as bubbling and cancelable.

    event.synthetic = true; // allow detection of synthetic events
    // The second parameter says go ahead with the default action
    node.dispatchEvent(event, true);
  } else if (node.fireEvent) {
    // IE-old school style, you can drop this if you don't need to support IE8 and lower
    const event = doc.createEventObject();
    event.synthetic = true; // allow detection of synthetic events
    node.fireEvent('on' + eventName, event);
  }
};

const urlB64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    // eslint-disable-next-line no-useless-escape
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const flipdiv = document.getElementById('flipdish-menu');

type ExtraOptionKeys =
  | 'data-base-href'
  | 'data-cookie-policy-link'
  | 'data-force-app'
  | 'data-full-screen-on-mobile'
  | 'data-initial-screen'
  | 'data-language'
  | 'data-menuid'
  | 'data-offset'
  | 'data-privacy-policy-link'
  | 'data-restaurant'
  | 'data-scrollable-container'
  | 'data-local-server'
  | 'data-store-ids'
  | 'data-terms-link'
  | 'data-theme'
  | 'data-webtoappredirect'
  | 'data-web-order-source'
  /** @description used by external embeds */
  | 'data-initial-language'
  /** @deprecated */
  | 'data-permissions';

export const extraOption = (key: ExtraOptionKeys): string | null => {
  const urlParam = extraOptionUrlParam(key);
  if (urlParam) {
    return urlParam;
  }

  return flipdiv && flipdiv.getAttribute(key);
};

const extraOptionUrlParam = (key: ExtraOptionKeys): string | null => {
  // For security reasons, only allow whitelisted URL params to be accepted.
  const urlParamWhitelist = [
    'data-force-app',
    'data-full-screen-on-mobile',
    'data-initial-language',
    'data-initial-screen',
    'data-language',
    'data-menuid',
    'data-offset',
    'data-scrollable-container',
    'data-store-ids',
    'data-theme',
    'data-webtoappredirect',
    'data-web-order-source',
  ];

  if (!urlParamWhitelist.includes(key)) {
    return;
  }

  if (!window.hasOwnProperty('URLSearchParams')) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

const translateTransform = (jsonFile: any) => {
  const translatedJson: any = {};

  for (const p in jsonFile) {
    if (jsonFile.hasOwnProperty(p)) {
      translatedJson[p] = jsonFile[p].value;
    }
  }

  return translatedJson;
};

// BUG this is wrong, diff locales can have ',' as decimal point
const regexPrice = (price: string) => {
  return price.match(/^\d*\.?\d?\d?$/);
};

// TODO purpose of this!!!!
const regexInt = (number: string) => {
  return number.match(/^\d*$/);
};

const setInLocalStorage = (key: string, data: any) => {
  //Try saving in localStorage
  try {
    storage.setItem(key, data);
  } catch (e) {
    //If localStorage full clear and then try again
    if (isQuotaExceeded(e)) {
      storage.clear();

      try {
        storage.setItem(key, data);
      } catch (err) {
        console.log(err.message);
      }
    } else {
      console.log(e.message);
    }
  }
};

const isQuotaExceeded = (e: any) => {
  let quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
};

const localStorageTotalSizeKb = () => {
  const total = Object.keys(window.localStorage)
    .reduce<number>((agg, key) => {
      const itemSize = ((localStorage[key].length + key.length) * 2) / 1024;
      return agg + itemSize;
    }, 0)
    .toFixed(2);

  // console.log('Total = ' + total + ' KB');
  return total;
};
const localStorageDetailSizeKb = () => {
  const totals = Object.keys(window.localStorage).reduce<{
    [key: string]: number;
    total: number;
  }>(
    (agg, key) => {
      const itemSize = ((localStorage[key].length + key.length) * 2) / 1024;
      agg[key] = itemSize;
      agg.total += itemSize;
      return agg;
    },
    { total: 0 },
  );

  return totals;
};

const returnColor = (color: string, fallback: string) => {
  if (color === '') {
    return fallback;
  } else if (color.charAt(0) !== '#') {
    return `#${color}`;
  } else {
    return color;
  }
};

const lastPhysicalRestaurantIdKey = (appName: string): string => {
  return `flipdish-${appName}-last-pr-id`;
};

const storeLastPhysicalRestaurantId = (
  appName: string,
  restaurantId: string,
): void => {
  Utilities.setInLocalStorage(
    lastPhysicalRestaurantIdKey(appName),
    restaurantId,
  );
};

const getLastPhysicalRestaurantId = (appName: string): string => {
  return storage.getItem(lastPhysicalRestaurantIdKey(appName)) || null;
};

const getFallbackStoreBaseUrl = () => {
  const state = getStoreInstance()?.getState();
  return state?.flipdish?.FallbackBaseUrl;
};

const getMalformedFlipdishTokenCookie = () => {
  const flipdishCookie = document.cookie
    .split(';')
    .find((cookieString) => cookieString.includes('flipdish-token'));

  const flipdishToken = flipdishCookie
    ? flipdishCookie
        .trim()
        .split('=')
        .pop()
    : '';

  return decodeURIComponent(flipdishToken);
};

const getFlipdishTokenCookie = () => {
  if (!document.cookie) return '';

  let flipdishToken = '';
  try {
    flipdishToken = cookie.get('flipdish-token');
  } catch (error) {
    flipdishToken = getMalformedFlipdishTokenCookie();
  }

  return flipdishToken;
};

const getLangauageFromStorage = () => {
  const wlID = extraOption('data-restaurant');
  return storage.getItem(`flipdish-${wlID}-customer-language`);
};

const setLangauageInStorage = (language) => {
  const wlID = extraOption('data-restaurant');
  storage.setItem(`flipdish-${wlID}-customer-language`, language);
};

const removeLangauageFromStorage = () => {
  const wlID = extraOption('data-restaurant');
  storage.removeItem(`flipdish-${wlID}-customer-language`);
};

const getAdditonalEmbedHeaders = () => {
  if (window.location.hostname.includes('localhost')) {
    return null;
  }
  const webOrderSource = extraOption('data-web-order-source') || '';
  if (webOrderSource === '') {
    return ({
      'Flipdish-Web-Order-Source': 'embed',
    });
  }
  return ({
    'Flipdish-Web-Order-Source': webOrderSource,
  });
}

export const Utilities = {
  CredentialsAuth,
  DeviceId,
  UUID,
  arrayMove,
  browserHasLocation,
  convertTimeZone,
  detectPrivateMode,
  difference,
  ensureVisible,
  extraOption,
  findAndRemove,
  fireEvent,
  flipdiv,
  getAdditonalEmbedHeaders,
  getFallbackStoreBaseUrl,
  getFlipdishTokenCookie,
  getLastPhysicalRestaurantId,
  getOpeningTime,
  getUserMessage,
  handleError,
  isAndroid,
  isChrome,
  isFirefox,
  isIOS,
  isIOSPhone,
  isInFrame,
  isInPeriod,
  isQuotaExceeded,
  isStandalone,
  isValidCreditCard,
  isValidEmail,
  loadMenu,
  localStorageDetailSizeKb,
  localStorageTotalSizeKb,
  navigateTo,
  preorderInfoText,
  regexInt,
  regexPrice,
  removeFromArray,
  returnColor,
  setInLocalStorage,
  startsWith,
  storeLastPhysicalRestaurantId,
  stringToJSX,
  timezoneIdToCountryCode,
  toPromise: toPromise,
  translateTransform,
  trimBasket,
  urlB64ToUint8Array,
  getLangauageFromStorage,
  setLangauageInStorage,
  removeLangauageFromStorage,
};
